import firebase from "firebase/compat";
import { db } from "firebaseConfig";
import { Button, Checkbox } from "@material-ui/core";
import { PinDrop } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { preventBubbling } from "utils/listings/helper";
import { useSnackbar } from "notistack5";
import type { FavoriteListingsOfContact } from "../../../@types/sharedSchema";

type ListingCardVisitsProps = {
  disabled?: boolean;
  listingId: string;
  favoriteListingsOfContact: FavoriteListingsOfContact;
};

export function ListingCardVisits({
  disabled,
  listingId,
  favoriteListingsOfContact
}: ListingCardVisitsProps): JSX.Element {
  const { t: translate } = useTranslation();

  const { enqueueSnackbar } = useSnackbar();

  const listingVisited = Boolean(
    favoriteListingsOfContact.listingIdsUserVisited?.includes(listingId)
  );

  const manageVisit = async (): Promise<void> => {
    if (listingVisited) {
      await db
        .collection("favorite-listings-of-contact")
        .doc(favoriteListingsOfContact.id)
        .update({
          listingIdsUserVisited: firebase.firestore.FieldValue.arrayRemove(listingId)
        });

      return;
    }

    await db
      .collection("favorite-listings-of-contact")
      .doc(favoriteListingsOfContact.id)
      .update({
        listingIdsUserVisited: firebase.firestore.FieldValue.arrayUnion(listingId)
      });

    enqueueSnackbar(translate("listingsMatch.listingMarkedAsVisited"), { variant: "success" });
  };

  return (
    <Button
      {...(listingVisited
        ? { sx: { color: "primary.main" }, color: "primary" }
        : { sx: { color: "text.secondary" }, color: "inherit" })}
      size="small"
      variant="outlined"
      disabled={disabled}
      startIcon={<Checkbox size="small" disabled={disabled} checked={listingVisited} />}
      endIcon={<PinDrop />}
      onClick={preventBubbling(manageVisit)}
    >
      {translate("listingsMatch.visitedButtonTitle")}
    </Button>
  );
}
